import React, { useEffect, useState, useContext } from "react";
import classNames from "classnames";
import Modal from "../../utils/components/common/modal";
import Icons from "../../utils/components/icons";
import { useTranslation } from "react-i18next";
import {
  getLocationAndHierarchyDetails,
  updateLocation,
  createLocation,
  deleteLocation,
} from "../../services/LocationService";
import { UserContext, OrganisationContext } from "../../layouts/MainLayout";
import LoadingSpinner from "../../utils/components/common/loadingSpinner/LoadingSpinner";
import "./locationDashboard.scss";
import ModalComponent from "../../utils/components/common/modalComponent/ModalComponent";

const LocationDashboard = () => {
  const { userData, userCognitoData } = useContext(UserContext);
  const { orgData, siteData } = useContext(OrganisationContext);

  const { t } = useTranslation("locationdashboard");
  const levelsType = {
    Level1: "Buildings",
    Level2: "Floors",
    Level3: "Rooms",
  };

  const [LocationData, setLocationData] = useState({});
  const [locationLevel, setLocationLevel] = useState("");
  const [locationLevelRender, setLocationLevelRender] = useState([]);
  const [editLevel, setEditLevel] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [editLevelError, setEditLevelError] = useState("");
  const [addNewLocation, setAddNewLocation] = useState("");
  const [newLocationLevel, setNewLocationLevel] = useState("");
  const [newLocationValue, setNewLocationValue] = useState("");

  const [apiError, setAPIError] = useState("");
  const [deletePK, setDeletePK] = useState("");
  const [isDeletConfirmModal, setIsDeletConfirmModal] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const iconsMapping = [Icons.buildingIcon, Icons.stairIcon, Icons.roomIcon];
  let keyText = "Level";
  const levelNameRegex = /^[A-Za-z0-9- _:]*$/;

  const getActiveSite = () => {
    let site = "";
    if (orgData?.SiteList && orgData?.SiteList.length > 0) {
      let arr = orgData?.SiteList;
      if (userData.UserRole !== "Super Admin") {
        arr?.forEach((elem) => {
          if (elem.HasAccess === "True" && elem.SiteStatus === "Enabled") {
            site = elem.SiteId;
            return false;
          }
        });
      } else {
        site = arr[0].SiteId;
      }
    }
    return site;
  };

  const getLocationHierarchyDetails = () => {
    setIsLoading(true);
    const queryParams = {
      organizationId: userData?.OrganizationID,
      locationHierarchy: userData?.OrganizationID + "#" + siteData.id,
      requestedByUserId: userCognitoData?.username,
      getLocationDeletableStatus: true,
    };
    getLocationAndHierarchyDetails(queryParams)
      .then((resp) => {
        setIsLoading(false);
        setLocationData(
          resp?.data?.Items
            ? {
                ...resp?.data,
                Items: {
                  ...resp.data.Items,
                  LevelMapping: resp.data.Items?.LevelMapping
                    ? resp.data.Items?.LevelMapping
                    : levelsType,
                },
              }
            : {}
        );
        if (resp?.data?.Items?.Level1 && resp.data.Items.Level1.length > 0) {
          if (newLocationLevel !== "") {
            if (newLocationLevel === null) {
              const currentIndex = resp.data.Items.Level1.findIndex(
                (item) =>
                  item.LocationName.toLowerCase() ===
                  newLocationValue.toLowerCase()
              );
              if (currentIndex > -1) {
                handleClick(`${currentIndex}`);
              }
            } else {
              const newLocationLevelArr = newLocationLevel.split("_");
              const currentSelection = getLevelVales(
                newLocationLevelArr,
                false,
                resp.data.Items
              );
              const currentSiblings =
                currentSelection[`${keyText}${newLocationLevelArr.length + 1}`];
              if (currentSiblings !== undefined) {
                const currentIndex = currentSiblings.findIndex(
                  (item) =>
                    item.LocationName.toLowerCase() ===
                    newLocationValue.toLowerCase()
                );
                if (currentIndex > -1) {
                  handleClick(`${newLocationLevel}_${currentIndex}`);
                }
              }
            }
          }
        }
      })
      .catch((error) => {
        // console.log(error);
        setIsLoading(false);
      });
  };

  const editLocationApi = (index) => {
    const indexArr = index.split("_");
    const currentSelection = getLevelVales(indexArr);
    const currentSiblings = getLevelVales(indexArr, true);

    const existingLevels = currentSiblings.find(
      (item) => item?.LocationName.toLowerCase() === inputValue.toLowerCase()
    );

    if (existingLevels?.PK && existingLevels.PK !== currentSelection.PK) {
      setEditLevelError(
        "The Location Name must be unique within a Parent Location. Please try again with a unique Location Name."
      );
      return false;
    } else {
      setEditLevelError("");
    }
    setIsLoading(true);
    const queryParam = {
      locationId: currentSelection.PK,
      locationName: inputValue,
      requestedByUserId: userCognitoData.username,
    };
    updateLocation(queryParam)
      .then((resp) => {
        setIsLoading(false);
        setEditLevel("");
        setAPIError("");
        setAddNewLocation("");
        getLocationHierarchyDetails();
        // setAPIError(resp.data.Message);
        // setIsErrorModal(true);
      })
      .catch((error) => {
        // console.log(error);
        setIsLoading(false);
        setAPIError(
          `The App couldn’t update the Location "${inputValue}". Please try again after some time.`
        );
        setIsErrorModal(true);
      });
  };

  const addLocationApi = (index) => {
    let currentSelection = {};
    let currentSiblings = [];
    if (index === null) {
      currentSelection = LocationData?.Items;
      currentSiblings = LocationData?.Items["Level1"];
    } else {
      const indexArr = index.split("_");
      currentSelection = getLevelVales(indexArr);
      currentSiblings = currentSelection[`${keyText}${indexArr.length + 1}`];
    }

    if (currentSiblings) {
      const existingLevels = currentSiblings.find(
        (item) => item.LocationName.toLowerCase() === inputValue.toLowerCase()
      );
      if (existingLevels?.PK && existingLevels.PK !== currentSelection.PK) {
        setEditLevelError(
          "The Location Name must be unique within a Parent Location. Please try again with a unique Location Name."
        );
        return false;
      } else {
        setEditLevelError("");
      }
    } else {
      setEditLevelError("");
    }

    setIsLoading(true);
    const queryParams = {
      parentLocationId: currentSelection.PK,
      locationName: inputValue,
      requestedByUserId: userCognitoData.username,
    };
    createLocation(queryParams)
      .then((resp) => {
        setNewLocationLevel(index);
        setIsLoading(false);
        setNewLocationValue(inputValue);
        setAPIError(resp.data.Message);
        setIsErrorModal(true);
      })
      .catch((error) => {
        // console.log(error);
        setIsLoading(false);
        setAPIError(
          `The App couldn’t create the Location "${inputValue}". Please try again after some time.`
        );
        setIsErrorModal(true);
      });
  };

  const handleLevelDelete = () => {
    const deletePKArr = deletePK.split("_");
    const currentSelection = getLevelVales(deletePKArr);
    setIsLoading(true);
    const queryParam = {
      locationId: currentSelection.PK,
      requestedByUserId: userCognitoData.username,
    };
    deleteLocation(queryParam)
      .then((resp) => {
        setIsLoading(false);
        if (deletePKArr.length === 1) {
          setLocationLevel("");
        } else {
          setLocationLevel(
            deletePKArr.slice(0, deletePKArr.length - 1).join("_")
          );
        }
        setAPIError(resp.data.Message);
        setIsErrorModal(true);
      })
      .catch((error) => {
        // console.log(error);
        setIsLoading(false);
        setDeletePK("");
        setAPIError(
          `The App couldn’t delete the Location "${inputValue}" successfully. Please try again after sometime.`
        );
        setIsErrorModal(true);
      });
  };

  const handleLevelDeleteConfermation = (event, index) => {
    event.stopPropagation();
    setDeletePK(index);
    setIsDeletConfirmModal(true);
  };

  /**
   * This function returns current level object [// getLevelVales('1_0_0_1');]
   * @param {Array} ['listArr'] level index combination array
   */
  const getLevelVales = (listArr = [], sibllings = false, data = null) => {
    let currentValue = data || LocationData?.Items;

    if (listArr.length) {
      for (let i = 0; i < listArr.length; i++) {
        let key = `Level${i + 1}`;
        if (sibllings && i + 1 === listArr.length) {
          currentValue = currentValue[key];
        } else {
          if (currentValue[key]) {
            currentValue = currentValue[key][listArr[i]];
          }
        }
      }
      return currentValue;
    }
    return currentValue;
  };

  /**
   * This function handles click on level cards
   * @param {string} ['index'] level index combination
   */
  const handleClick = (index) => {
    if (locationLevel?.indexOf(index) === 0) return false;

    const currentSelection = getLevelVales(index.split("_"));
    setInputValue(currentSelection?.LocationName);
    setEditLevel("");
    setNewLocationLevel("");
    setNewLocationValue("");
    setAddNewLocation("");
    setLocationLevel(index);
  };

  /**
   * This function handles edit button click on level cards
   * @param {object} ['event'] click event object
   * @param {string} ['index'] level index combination
   */
  const handleEditClick = (event, index) => {
    event.stopPropagation();
    setEditLevelError("");
    setAddNewLocation("");
    const currentSelection = getLevelVales(index.split("_"));
    setInputValue(currentSelection?.LocationName);
    setEditLevel(index);
  };

  /**
   * This function handles cancel edit button click on level cards
   * @param {object} ['event'] click event object
   */
  const handleCancelEdit = (event) => {
    event.stopPropagation();
    setEditLevel("");
    setEditLevelError("");
  };

  /**
   * This function handles input onChange
   * @param {object} ['event'] click event object
   */
  const handleInputChange = (event) => {
    if (event.target.value.length === 0) {
      setInputValue(event.target.value);
      setEditLevelError(t("blank_error"));
    } else {
      if (levelNameRegex.test(event.target.value)) {
        setInputValue(event.target.value);
        setEditLevelError("");
      } else {
        setInputValue(event.target.value);
        setEditLevelError(t("invalid_characters_error"));
      }
    }
  };

  /**
   * This function handles input onKeyDown
   * @param {object} ['event'] click event object
   */
  const handleInputKeyDown = (event, index) => {
    if (event.keyCode === 13) {
      editLocationApi(index);
      event.target.blur();
    }
  };

  const handleAddLocationKeyDown = (event, index) => {
    if (event.keyCode === 13) {
      addLocationApi(index);
      event.target.blur();
    }
  };

  const handleAddNewLocationClick = (event, index) => {
    event.stopPropagation();
    setInputValue("");
    setEditLevel("");
    setAddNewLocation(index);
    setEditLevelError("");
  };

  const handleCancelAddLocation = (event) => {
    event.stopPropagation();
    setAddNewLocation("");
    setEditLevelError("");
  };

  const addLocationButton = (levelTitle, index = null) => {
    const iconIndex = index ? index.split("_").length : 0;
    return (
      <div
        className={classNames("levelCard addLocation", {
          "active editable": addNewLocation === index,
        })}
        onClick={(e) => handleAddNewLocationClick(e, index)}
        key={`add_location${index}`}
        id={`Add ${levelTitle}`}
      >
        <div className="levelCardLeft justify-content-center">
          {addNewLocation === index ? iconsMapping[iconIndex] : Icons.addIcon}
          {addNewLocation !== index && <span>{`Add ${levelTitle}`}</span>}
          {addNewLocation === index && (
            <input
              type="text"
              placeholder={`Enter ${levelTitle} name`}
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={(e) => handleAddLocationKeyDown(e, index)}
              minLength="1"
              maxLength="16"
              id="enter_location_name"
            />
          )}
        </div>
        {addNewLocation === index && (
          <div className="levelCardRight justify-content-center">
            <button
              onClick={(e) => handleCancelAddLocation(e)}
              title={t("cancel_tooltip")}
              name={t("cancel_tooltip")}
            >
              {Icons.closeCircleIcon}
            </button>
          </div>
        )}
        {addNewLocation === index && editLevelError !== "" && (
          <div className="editLevelError">{editLevelError}</div>
        )}
      </div>
    );
  };

  const setLocationRenderer = () => {
    const initialLevel = [[]];
    if (LocationData?.Items["Level1"]) {
      LocationData?.Items["Level1"]?.forEach((elem, index) => {
        let indx = index.toString();
        initialLevel[0].push(
          <div
            className={classNames("levelCard", {
              active: locationLevel.indexOf(indx) === 0,
              editable: editLevel === indx,
            })}
            name={`levelCard_${index}`}
            onClick={() => handleClick(indx)}
            key={`level_${indx}`}
          >
            <div className="levelCardLeft">
              {iconsMapping[0]}
              {editLevel !== indx && (
                <span id={`label_${indx}`} title={elem.LocationName}>
                  {elem.LocationName}
                </span>
              )}
              {editLevel === indx && (
                <input
                  type="text"
                  placeholder={`Enter ${LocationData?.Items?.LevelMapping["Level1"]} name`}
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={(e) => handleInputKeyDown(e, indx)}
                  minLength="1"
                  maxLength="16"
                  id="edit_location_name"
                />
              )}
            </div>
            {locationLevel.indexOf(indx) === 0 && (
              <div className="levelCardRight">
                {editLevel !== indx && (
                  <div className="d-flex flex-column justify-content-between flex-grow align-items-center">
                    <button
                      onClick={(e) => handleEditClick(e, indx)}
                      title={t("edit_tooltip")}
                      name={t("edit_tooltip")}
                      className={t("editLocation_button_id")}
                    >
                      <span id={t("editLocation_icon_id")}>
                        {Icons.editFillIcon}
                      </span>
                    </button>
                    <button
                      onClick={() => {}}
                      title={t("Copy_Move_tooltip")}
                      name={t("Copy_Move_tooltip")}
                      className="copyMoveLocationIcon"
                    >
                      <span id="copy&MoveLocationIcon">
                        {Icons.copyMoveIcon}
                      </span>
                    </button>
                  </div>
                )}
                {editLevel === indx && (
                  <div className="d-flex flex-column justify-content-between flex-grow align-items-center cancelActionWrapper">
                    <button
                      onClick={(e) => handleCancelEdit(e)}
                      title={t("cancel_tooltip")}
                      name={t("cancel_tooltip")}
                    >
                      <span id="cancelIcon">
                        {Icons.locationCLoseCircleIcon}
                      </span>
                    </button>
                    <button
                      onClick={(e) => handleLevelDeleteConfermation(e, indx)}
                      title={t("delete_tooltip")}
                      name={t("delete_tooltip")}
                      disabled={!LocationData?.LocationDeletableStatus[elem.PK]}
                    >
                      <span
                        id={t("delete_icon_id")}
                        className={
                          !LocationData?.LocationDeletableStatus[elem.PK] &&
                          "del_icon_disable"
                        }
                      >
                        {Icons.locationDeleteIcon}
                      </span>
                    </button>
                  </div>
                )}
              </div>
            )}
            {editLevel === indx && editLevelError !== "" && (
              <div className="editLevelError">{editLevelError}</div>
            )}
          </div>
        );
      });
    }
    if (initialLevel[0].length < 99) {
      initialLevel[0].push(
        addLocationButton(LocationData?.Items?.LevelMapping["Level1"])
      );
    }

    if (locationLevel.length > 0) {
      const level = locationLevel.split("_");
      level?.forEach((elem, index) => {
        const indexCombination = level.slice(0, index + 1);
        const currentSelection = getLevelVales(indexCombination);
        if (
          locationLevel.split("_").length <
          Object.keys(LocationData?.Items?.LevelMapping).length
        ) {
          //
        }
        initialLevel[initialLevel.length] = [];
        if (currentSelection[`${keyText}${index + 2}`] !== undefined) {
          currentSelection[`${keyText}${index + 2}`]?.forEach((itm, ind) => {
            const indexComboSubLeve = [...indexCombination, ind].join("_");
            initialLevel[initialLevel.length - 1].push(
              <div
                className={classNames("levelCard", {
                  active: locationLevel.indexOf(indexComboSubLeve) === 0,
                  editable: editLevel === indexComboSubLeve,
                })}
                onClick={() => handleClick(indexComboSubLeve)}
                key={`level_${indexComboSubLeve}`}
              >
                <div className="levelCardLeft">
                  {iconsMapping[index + 1] || Icons.roomIcon}
                  {editLevel !== indexComboSubLeve && (
                    <span title={itm.LocationName}>{itm.LocationName}</span>
                  )}
                  {editLevel === indexComboSubLeve && (
                    <input
                      type="text"
                      placeholder={`Enter ${
                        LocationData?.Items.LevelMapping[
                          `${keyText}${index + 2}`
                        ]
                      } name`}
                      value={inputValue}
                      onChange={handleInputChange}
                      onKeyDown={(e) =>
                        handleInputKeyDown(e, indexComboSubLeve)
                      }
                      minLength="1"
                      maxlength="16"
                      id="edit_location_name"
                    />
                  )}
                </div>
                {locationLevel.indexOf(indexComboSubLeve) === 0 && (
                  <div className="levelCardRight">
                    {editLevel !== indexComboSubLeve && (
                      <>
                        <div className="d-flex flex-column justify-content-between flex-grow align-items-center">
                          <button
                            onClick={(e) =>
                              handleEditClick(e, indexComboSubLeve)
                            }
                            title={t("edit_tooltip")}
                            name={t("edit_tooltip")}
                            className={t("editLocation_button_id")}
                          >
                            <span id={t("editLocation_icon_id")}>
                              {Icons.editFillIcon}
                            </span>
                          </button>
                          <button
                            onClick={() => {}}
                            title={t("Copy_Move_tooltip")}
                            name={t("Copy_Move_tooltip")}
                            className="copyMoveLocationIcon"
                          >
                            {Icons.copyMoveIcon}
                          </button>
                        </div>
                        {editLevel === indexComboSubLeve &&
                          editLevelError !== "" && (
                            <div className="editLevelError">
                              {editLevelError}
                            </div>
                          )}
                      </>
                    )}
                    {editLevel === indexComboSubLeve && (
                      <div className="d-flex flex-column justify-content-between flex-grow align-items-center cancelActionWrapper">
                        <button
                          onClick={(e) => handleCancelEdit(e)}
                          title={t("cancel_tooltip")}
                          name={t("cancel_tooltip")}
                        >
                          <span id={t("cancel_icon_id")}>
                            {Icons.closeCircleIcon}
                          </span>
                        </button>
                        <button
                          onClick={(e) =>
                            handleLevelDeleteConfermation(e, indexComboSubLeve)
                          }
                          title={t("delete_tooltip")}
                          name={t("delete_tooltip")}
                          disabled={
                            !LocationData?.LocationDeletableStatus[itm.PK]
                          }
                        >
                          <span
                            id={t("delete_icon_id")}
                            className={
                              !LocationData?.LocationDeletableStatus[itm.PK] &&
                              "del_icon_disable"
                            }
                          >
                            {Icons.deleteIcon}
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                )}
                {editLevel === indexComboSubLeve && editLevelError !== "" && (
                  <div className="editLevelError">{editLevelError}</div>
                )}
              </div>
            );
          });
        }
        if (
          index < Object.keys(LocationData?.Items?.LevelMapping).length - 1 &&
          initialLevel[initialLevel.length - 1].length < 99
        ) {
          initialLevel[initialLevel.length - 1].push(
            addLocationButton(
              LocationData?.Items.LevelMapping[`${keyText}${index + 2}`] ||
                `${keyText}${index + 2}`,
              indexCombination.join("_")
            )
          );
        }
      });
    }
    setLocationLevelRender(initialLevel);
  };

  useEffect(() => {
    if (LocationData?.Items) {
      setLocationRenderer();
    }
  }, [
    LocationData,
    locationLevel,
    editLevel,
    inputValue,
    editLevelError,
    addNewLocation,
  ]);

  useEffect(() => {
    if (
      userData?.OrganizationID &&
      userCognitoData?.username &&
      orgData?.SiteList
    ) {
      getLocationHierarchyDetails();
    }
  }, [userData, userCognitoData, orgData, siteData]);

  const onModalAcceptance = () => {
    setIsErrorModal(false);
    setEditLevel("");
    setAPIError("");
    setAddNewLocation("");
    getLocationHierarchyDetails();
  };

  const onModalDeleteConfirmation = () => {
    setIsDeletConfirmModal(false);
    setDeletePK("");
    setEditLevel("");
    handleLevelDelete();
  };

  const onModalDeleteCancel = () => {
    setIsDeletConfirmModal(false);
    setDeletePK("");
  };

  const getHeadings = (currentLevelLength) => {
    const levelsArray = {
      0: ["Buildings", "Floors", "Rooms"],
      1: ["Floors", "Rooms"],
      2: ["Rooms"],
    };
    return (
      <div>
        {currentLevelLength < 3 ? (
          levelsArray[currentLevelLength].map((levels) => {
            return (
              <div className="mt-5" key={`level_sections_${levels}`}>
                <div
                  className="levelHeading d-flex fluid align-items-center disabled"
                  id={`collapsed_${levels}`}
                >
                  <span name="collapsedBtn">{Icons.sideArrowIcons}</span>
                  <span id={levels}>{levels}</span>
                </div>
              </div>
            );
          })
        ) : (
          <></>
        )}
      </div>
    );
  };

  const getOriginalObj = (deletePKId) => {
    if (!deletePKId) return;
    const deletePKIdArr = deletePKId.split("_");
    return getLevelVales(deletePKIdArr);
  };

  return (
    <div className="bodyInner pb-4 h-auto locationDashoard">
      <div className="bodyContainer withWhiteBg pb-4">
        <div className="controllesWrapper mb-3 mt-1 pe-4 ps-4 pt-4">
          <div id="location_count" className="">
            <span className="totalCount">{Icons.locationIcon} Locations</span>
          </div>
        </div>
        <div className="gridViewWrapper ps-4">
          <div className="gridViewInner mb-5">
            <div className="d-flex flex-wrap fluid mb-4">
              {locationLevelRender.map((item, index) => (
                <div
                  className="d-flex flex-wrap fluid"
                  key={`level_sections_${index + 1}`}
                >
                  {item.length ? (
                    <>
                      <div
                        className="levelHeading d-flex fluid align-items-center"
                        id={`${
                          LocationData?.Items.LevelMapping[
                            `${keyText}${index + 1}`
                          ] || `${keyText}${index + 1}`
                        }Heading`}
                      >
                        <span name="expandedBtn">{Icons.downArrowIcon}</span>
                        <span
                          id={
                            LocationData?.Items.LevelMapping[
                              `${keyText}${index + 1}`
                            ] || `${keyText}${index + 1}`
                          }
                        >
                          {LocationData?.Items.LevelMapping[
                            `${keyText}${index + 1}`
                          ] || `${keyText}${index + 1}`}
                        </span>
                      </div>
                      <div
                        className="d-flex flex-wrap fluid mt-4"
                        id="cardContainer"
                      >
                        {item.map((itm) => itm)}
                      </div>
                    </>
                  ) : null}
                </div>
              ))}
              <div>{getHeadings(locationLevelRender.length)}</div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LoadingSpinner />}

      <ModalComponent
        idName="location_error_modal"
        isOpen={isErrorModal}
        onCloseModal={() => setIsErrorModal(false)}
        onAcceptance={onModalAcceptance}
        descriptionText={apiError}
      ></ModalComponent>

      <ModalComponent
        idName="location_delete_modal"
        isOpen={isDeletConfirmModal}
        onCloseModal={() => setIsDeletConfirmModal(false)}
        descriptionText={t("delete_confirmation", {
          inputValue: getOriginalObj(deletePK)?.LocationName,
        })}
        needConfirmation={true}
        onConfirm={onModalDeleteConfirmation}
        onClose={onModalDeleteCancel}
      ></ModalComponent>
    </div>
  );
};

export default LocationDashboard;
